// src/hooks/useLanguage.ts - расширенная версия
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useLanguage = () => {
  const { i18n, t } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      setLanguage(lng);
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  // Добавляем функцию для проверки существования перевода
  const exists = (key: string): boolean => {
    const value = t(key, { returnObjects: true });
    // Если ключ не существует, i18next вернет сам ключ
    return typeof value === 'string' && value !== key;
  };

  return { 
    language, 
    changeLanguage,
    availableLanguages: ['en', 'ru'],
    t, // Экспортируем функцию перевода для удобства
    i18n, // Экспортируем i18n для прямого доступа
    exists // Экспортируем функцию проверки
  };
};